import {combineEpics, ofType, PledgerAction, PledgerEpic} from "@pledger/frontend-commons";
import {map} from "rxjs/operators";
import {CreateSouscriptionActions} from "./CreateSouscriptionActions";

import {souscriptionCGPEpics} from "./SouscriptionCGP/SouscriptionCGPEpics";
import {souscriptionSelfcareEpics} from "./SouscriptionSelfcare/SouscriptionSelfcareEpics";
import {souscriptionCGPWServiceActions} from "../../services/ws/SouscriptionCGP/souscriptionCGPWServiceActions";

/*const emptyEpic : PledgerEpic<any> = (actions$ : Observable<PledgerAction>) => of(AppActions.EMPTY_ACTION.build());*/

const pageLoadedEpic : PledgerEpic<any> = (actions$) =>
    actions$.pipe(
        ofType(CreateSouscriptionActions.CREATE_SOUSCRIPTION_PAGE_LOADED_ACTION.type),
        map((action : PledgerAction) => {
            return souscriptionCGPWServiceActions.GET_SOUSCRIPTION_CGP_REFERENCES_ACTION.build();
        }));

export const createSouscriptionEpics = combineEpics(
     pageLoadedEpic,
    souscriptionCGPEpics,
    souscriptionSelfcareEpics
);
